<!-- @format -->

<div class="enrolment-state" data-cy="enrolment-state-text">
  @if (enrolment.state === "ENROLLED") {
    <sis-icon icon="check"></sis-icon>
  }
  @if (enrolment.state !== "NOT_ENROLLED") {
    @if (enrolment.state === "ENROLLED" && (courseUnitRealisation.activityPeriod | dateRangeOngoing)) {
      <span>{{ "COURSE_UNIT_REALISATION.ENROLMENT_STATE_FOR_VIEW.ENROLLED_IN_PROGRESS" | translate }}</span>
    } @else {
      <span>{{ "COURSE_UNIT_REALISATION.ENROLMENT_STATE_FOR_VIEW." + enrolment.state | translate }}</span>
    }
  }
</div>
